import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Tooltip } from "antd";
import {
	DesktopOutlined,
	LogoutOutlined,
	MinusOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import { signOut } from "redux/actions/Auth";
import {
	incrementLayoutZoom,
	decrementLayoutZoom,
} from "redux/actions/Gui";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { THEME_KEYS } from "utils/themeDisplay";

const initials = (name) => {
	if (!name || typeof name !== "string") return "?";
	const p = name.trim().split(/\s+/).filter(Boolean);
	if (p.length === 0) return "?";
	if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
	return (p[0][0] + p[p.length - 1][0]).toUpperCase();
};

const SideNavFooter = ({
	collapsed,
	currentTheme,
	user,
	layoutZoom,
	signOut: signOutAction,
	incrementLayoutZoom: incZoom,
	decrementLayoutZoom: decZoom,
}) => {
	const isLight = currentTheme === THEME_KEYS.LIGHT;
	const roleText =
		user?.role !== undefined && user?.role !== null
			? String(user.role)
			: "";

	const zoomRow = (
		<div
			className={`side-nav-footer__zoom ${collapsed ? "side-nav-footer__zoom--collapsed" : ""}`}
		>
			<div className="side-nav-footer__zoom-head">
				<DesktopOutlined className="side-nav-footer__zoom-icon" />
				{!collapsed && (
					<span className="side-nav-footer__zoom-title">ZOOM</span>
				)}
			</div>
			<div className="side-nav-footer__zoom-controls">
				<Tooltip title="Diminuir">
					<Button
						type="text"
						size="small"
						icon={<MinusOutlined />}
						onClick={() => decZoom()}
						className="side-nav-footer__zoom-btn"
					/>
				</Tooltip>
				{!collapsed && (
					<span className="side-nav-footer__zoom-value">{layoutZoom}%</span>
				)}
				{collapsed && (
					<span className="side-nav-footer__zoom-value-mini">{layoutZoom}</span>
				)}
				<Tooltip title="Aumentar">
					<Button
						type="text"
						size="small"
						icon={<PlusOutlined />}
						onClick={() => incZoom()}
						className="side-nav-footer__zoom-btn"
					/>
				</Tooltip>
			</div>
		</div>
	);

	const userRow = (
		<div
			className={`side-nav-footer__user ${isLight ? "side-nav-footer__user--light" : "side-nav-footer__user--dark"}`}
		>
			<Link
				to={`${APP_PREFIX_PATH}/lista-regras-alertas`}
				className="side-nav-footer__user-main"
			>
				<div className="side-nav-footer__avatar">{initials(user?.name)}</div>
				{!collapsed && (
					<div className="side-nav-footer__user-text">
						<div className="side-nav-footer__user-name">
							{(user?.name || "—").toUpperCase()}
						</div>
						{roleText ? (
							<div className="side-nav-footer__user-role">{roleText}</div>
						) : null}
					</div>
				)}
			</Link>
			<Tooltip title="Sair">
				<Button
					type="text"
					size="small"
					icon={<LogoutOutlined />}
					onClick={() => signOutAction()}
					className="side-nav-footer__logout"
				/>
			</Tooltip>
		</div>
	);

	return (
		<div
			className={`side-nav-footer ${collapsed ? "side-nav-footer--collapsed" : ""}`}
		>
			{zoomRow}
			{userRow}
		</div>
	);
};

const mapState = ({ theme, user, gui }) => ({
	currentTheme: theme.currentTheme,
	user,
	layoutZoom: gui.layoutZoom ?? 100,
});

export default connect(mapState, {
	signOut,
	incrementLayoutZoom,
	decrementLayoutZoom,
})(SideNavFooter);
